import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LessonplanRoutingModule } from './lessonplan-routing.module';
import { ActivityTypeComponent } from './activity-type/activity-type.component';
import { LessonPlanningComponent } from './lesson-planning/lesson-planning.component';
import { DailyClassPlanningComponent } from './daily-class-planning/daily-class-planning.component';
import { OtherPlanningComponent } from './other-planning/other-planning.component';
import { AdminModule } from '../admin/admin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';


@NgModule({
  declarations: [ActivityTypeComponent, LessonPlanningComponent, DailyClassPlanningComponent, OtherPlanningComponent],
  imports: [
    CommonModule,
    LessonplanRoutingModule,
    AdminModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot()
  ]
})
export class LessonplanModule { }
